import styled from 'styled-components';

import { ContainerType } from 'flow/editor/components/NodeEditorDrawer/ThresholdsTab/types';


export const StyledRightValue = styled.span<{ actionType?: string; containerType?: ContainerType }>`
  ${({ actionType, containerType }) => ((
    actionType === 'input'
    && (containerType === ContainerType.TOOLTIP || containerType === ContainerType.TAB)
  ) ? `
    color: var(--cl-pink-600);
  ` : '')}
  word-break: break-word;
`;

export const StyledSpan = styled.span<{ actionType?: string; containerType?: ContainerType }>`
  ${props => ((props.actionType === 'input' && props.containerType === ContainerType.TOOLTIP) ? `
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 420px;
    word-break: break-word;
  ` : '')}
`;
